export const ADD_DISCOUNT = "ADD_DISCOUNT"
export const SELECT_DISCOUNT = "SELECT_DISCOUNT"
